import { useState } from "react";

const WHATSAPP_NUMBER = "5511991841569";
const WHATSAPP_MESSAGE = "Olá! Gostaria de saber mais sobre as soluções da Solus IT.";

export default function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="Fale conosco pelo WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-8 right-8 z-50 flex items-center gap-3 cursor-pointer"
      style={{ textDecoration: "none" }}
    >
      {/* Tooltip */}
      <div
        className="whitespace-nowrap text-white text-sm font-semibold px-4 py-2 rounded-full shadow-md transition-all duration-300"
        style={{
          background: "#25D366",
          opacity: hovered ? 1 : 0,
          transform: hovered ? "translateX(0)" : "translateX(8px)",
          pointerEvents: "none",
        }}
      >
        Fale conosco
      </div>

      {/* Button */}
      <div
        className="w-14 h-14 flex items-center justify-center rounded-full text-white text-2xl transition-transform duration-300"
        style={{
          background: "#25D366",
          boxShadow: "0 4px 20px rgba(37,211,102,0.45)",
          transform: hovered ? "scale(1.1)" : "scale(1)",
        }}
      >
        <i className="ri-whatsapp-line" style={{ fontSize: "1.6rem" }}></i>
      </div>
    </a>
  );
}
